let UTILS = require("../libs/utils.js");
var v7704;
var v7705;
module.exports = {
  id: "clas",
  name: "Classic FFA",
  alias: "clas",
  leaderStats: ["score", "kills", "deaths"],
  party: true,
  tag: ["Party", "#ffac00", "#ffb600"],
  noSliding: true,
  noKnives: true,
  noStreaks: true,
  noWallJ: true,
  impulseMlt: 0,
  noPickups: true,
  noMelee: true,
  realMov: true
};